import { useFormContext } from "./formElements";
import { useAuth } from "../../providers/authprovider";
import { Alert, Button, Form, Spinner } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export function FileUploader(props) {
  const element = props.value;
  const { onChange, onFileAdd, onFileRemove, protocolId } = useFormContext();
  const {
    protocols: { getFile },
  } = useAuth();
  const maxFilesCount = element.maxFilesCount ?? 1;
  const files = element.files || [];
  const [fileNames, setFileNames] = useState({});
  const [previews, setPreviews] = useState({});
  const [loadingIds, setLoadingIds] = useState({});
  const objectUrls = useRef([]);

  console.log("FileUploader render", { files });

  // Pobierz z serwera podgląd każdego pliku, który jest już zapisany
  // (ma uuid w element.files), a nie mamy go jeszcze lokalnie (np. po
  // ponownym wejściu w edycję zapisanego protokołu).
  useEffect(() => {
    if (!protocolId) return;

    files.forEach((fileId) => {
      if (!fileId || previews[fileId] || loadingIds[fileId]) return;

      setLoadingIds((prev) => ({ ...prev, [fileId]: true }));

      getFile(protocolId, fileId, ({ success, content }) => {
        setLoadingIds((prev) => {
          const copy = { ...prev };
          delete copy[fileId];
          return copy;
        });

        if (!success) return;

        const url = URL.createObjectURL(
          new Blob([content.file], { type: content.type })
        );
        objectUrls.current.push(url);
        setPreviews((prev) => ({ ...prev, [fileId]: url }));
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files, protocolId]);

  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      objectUrls.current.forEach((url) => URL.revokeObjectURL(url));
    };
  }, []);

  const handleFileChange = (index, file) => {
    if (!file) return;

    const id = uuidv4();
    const updatedFiles = [...files];
    updatedFiles[index] = id;
    element.files = updatedFiles;

    setFileNames((prev) => ({ ...prev, [index]: file.name }));

    const localUrl = URL.createObjectURL(file);
    objectUrls.current.push(localUrl);
    setPreviews((prev) => ({ ...prev, [id]: localUrl }));

    onFileAdd(id, file);
    onChange(element);
  };

  const handleRemoveFile = (index) => {
    const id = files[index];

    if (id) onFileRemove(id);

    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    element.files = updatedFiles;

    setFileNames((prev) => {
      const copy = { ...prev };
      delete copy[index];
      return copy;
    });

    onChange(element);
  };

  return (
    <div className="m-2 p-3 border rounded bg-white">
      <Form.Control
        type="text"
        value={element.label || ""}
        placeholder="Tytuł"
        className="border-0 bg-transparent fs-5 mb-2"
        onChange={(event) => {
          element.label = event.target.value;
          onChange(element);
        }}
      />
      {Array.from({ length: maxFilesCount }).map((_, index) => {
        const fileId = files[index];
        const previewUrl = fileId ? previews[fileId] : undefined;
        const isLoading = fileId && loadingIds[fileId];

        return (
          <div key={index} className="mb-3">
            <div className="d-flex align-items-center gap-2 mb-2">
              <Form.Control
                type="file"
                accept="image/jpeg,image/png"
                onChange={(event) =>
                  handleFileChange(index, event.target.files[0])
                }
              />
              {fileId && (
                <>
                  <span className="text-truncate" style={{ maxWidth: 200 }}>
                    {fileNames[index] || "Plik zapisany"}
                  </span>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRemoveFile(index)}
                    title="Usuń plik"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </>
              )}
            </div>
            {isLoading && <Spinner animation="border" size="sm" />}
            {previewUrl && (
              <img
                src={previewUrl}
                alt={fileNames[index] || "Podgląd pliku"}
                style={{ maxWidth: 200, maxHeight: 200 }}
                className="d-block border rounded"
              />
            )}
          </div>
        );
      })}
      <Alert variant="info" className="mb-0 mt-2">
        Aby zobaczyć dodane pliki w podglądzie, protokół musi zostać najpierw zapisany.
      </Alert>
    </div>
  );
}
